import { IProductoCarritoData } from '@core/interfaces/entidades/productoCarrito.entidad';
import {
  GestionTiempoItemRes,
  GestionTiempoRes,
} from '@core/interfaces/request-response/gestion-tiempo.dto.interface';

export const calcularTiempoRestanteGestion = (gestionTiempo: GestionTiempoRes) => {
  const totalminutos = gestionTiempo.items.reduce(
    (acc, item) => acc + (Number(item.duracion_minutos) || 0) * item.cantidad,
    0,
  );
  const inicio = gestionTiempo.inicio;
  const inicioDate = typeof inicio === 'string' ? new Date(inicio) : inicio;

  return calcularTiempoRestante(inicioDate, totalminutos);
};
/**
 * Calculates the remaining time in seconds between now and a deadline.
 * @param inicio - The start date from which the total time is measured
 * @param tiempoTotalMinutos - The total duration in minutes
 * @returns The remaining time in seconds, or 0 if the deadline has passed
 */
export const calcularTiempoRestante = (inicio: Date, tiempoTotalMinutos: number): number => {
  const ahora = new Date();
  const fin = new Date(inicio.getTime() + tiempoTotalMinutos * 60000);
  const diferencia_ms = fin.getTime() - ahora.getTime();
  return Math.max(0, Math.floor(diferencia_ms / 1000));
};

// crea funcion para trasducir de mili segundos a formato HH:MM:SS
export const formatearTiempo = (segundos: number): string => {
  const horas = Math.floor(segundos / 3600);
  const minutos = Math.floor((segundos % 3600) / 60);
  const segs = segundos % 60;
  return `${horas.toString().padStart(2, '0')}:${minutos.toString().padStart(2, '0')}:${segs
    .toString()
    .padStart(2, '0')}`;
};

export const gestionTiempoItemToCarritoProducto = (
  items: GestionTiempoItemRes[],
): IProductoCarritoData[] => {
  return items.map((item) => ({
    id: item.producto_id,
    nombre: item.nombre_producto,
    codigo: item.codigo_producto,
    stock: 0,
    controlar_stock: false,
    cantidad: item.cantidad,
    precio: item.precio_unitario,
    nota: item.nota || undefined,
  }));
};
export const carritoProductoToGestionTiempoItem = (
  productos: IProductoCarritoData[],
): GestionTiempoItemRes[] => {
  return productos.map((producto) => ({
    id: 0,
    producto_id: producto.id,
    nombre_producto: producto.nombre,
    codigo_producto: producto.codigo || null,
    precio_unitario: producto.precio,
    cantidad: producto.cantidad,
    subtotal: producto.precio * producto.cantidad,
    duracion_minutos: producto.producto_servicio?.duracion_minutos || null,
    nota: producto.nota || null,
  }));
};
